import {
  Button,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
} from "@themesberg/react-bootstrap";
import React, { useState } from "react";
import { axiosInstance } from "../../../../config/axios";
import { APIURL } from "../../../../configApi";
import { NotificationManager } from "react-notifications";

const AddGroupe = (props) => {
  const { refreshGroupeList } = props;
  const [groupe_name, setGroupe_Name] = useState("");
  const storeGroupre = (e) => {
    e.preventDefault();
    axiosInstance
      .post(`${APIURL}/laboratory/groups`, { name: groupe_name })
      .then((res) => {
        // console.log(res.data);
        NotificationManager.success(
          "Groupe ajouté avec succès",
          "Notification"
        );
        refreshGroupeList();
        setGroupe_Name("");
      })
      .catch((err) => {
        // console.log(err);
        NotificationManager.error(
          "Erreur lors de l'ajout d'un Groupe",
          "Notification"
        );
      });
  };

  return (
    <Form className={"d-flex align-items-end"} onSubmit={storeGroupre}>
      <FormGroup className={"w-75 me-4"}>
        <FormLabel>Nom du groupe</FormLabel>
        <FormControl
          type={"text"}
          placeholder={"Nom du groupe ..."}
          value={groupe_name}
          onChange={(e) => setGroupe_Name(e.target.value)}
          maxLength={50}
        ></FormControl>
      </FormGroup>
      <FormGroup>
        <Button variant={"btn btn-primary"} type={"submit"}>
          {" "}
          Sauvegarder{" "}
        </Button>
      </FormGroup>
    </Form>
  );
};

export default AddGroupe;
